export class RegisterSearchParams {
  skip = 0;
  take = 20;
  searchBy: RegisterSearchBy = RegisterSearchBy.Number;
  firstName?: string;
  lastName?: string;
  regNumber?: string;
}

export enum RegisterSearchBy {
  Number = 1,
  Name = 2
}

export interface RegisterSearchResult {
  gphcId?: string;
  title?: string;
  registrationNumber: string;
  forenames: string;
  surname: string;
  town: string;
  learningContractResponse: any;
  eligibleAsTutor: boolean;
}
